import React, { useEffect, useRef, useState } from "react";
import moment from "moment";

import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput, FormikYesOrNoInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as Yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    modalData,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";
import { ACTIONS } from "consts/Actions";

import { RequestServiceActions } from "services/services-mia/RequestServiceActions";

import styles from "styles/pages/ModalActions.module.scss";
import { Box, Paper } from "@mui/material";

const prioridadList = [
    {
        label: "Indistinto",
        value: "N"
    },
    {
        label: "Primero internos",
        value: "I"
    },
    {
        label: "Primero externo",
        value: "E"
    }
]

export default function InsertModal({ handleUpdateTable }) {
    const [inRequest, setInRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [disabledGroup, setDisabledGroup] = useState(false)
    const formikRef = useRef()
    const credentials = useRecoilValue(userCredentials);

    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const setModalDetails = useSetRecoilState(modalData);

    const handleSubmit = async ({
        tipoDeDocumentoNombre,
        tipoDeDocumentoDescripcion,
        tipoDeDocumentoCod,
        enviaMail,
        agrupa,
        agrupaCant,
        prioridadFirma,
        PHFirmante,
        PHTickets
    }) => {
        setInRequest((inRequest) => !inRequest);
        setIsLoading((isLoading) => !isLoading);

        const body = {
            service: "SBMTipoDeDocumentoIns",
            params: {
                sbmTipoDeDocumentoCod: tipoDeDocumentoCod || null,
                sbmTipoDeDocumentoNombre: tipoDeDocumentoNombre,
                sbmTipoDeDocumentoDescripcion: tipoDeDocumentoDescripcion,
                sbmTipoDeDocumentoMailer: enviaMail === true ? "Y" : "N",
                sbmTipoDeDocumentoAgrupa: agrupa === true ? "Y" : "N",
                sbmTipoDeDocumentoAgrupaCantidad: Number(agrupaCant),
                sbmTipoDeDocumentoPrioridadIntExt: prioridadFirma,
                sbmTipoDeDocumentoPHFirmantes: PHFirmante === true ? "Y" : "N",
                sbmTipoDeDocumentoPHTickets: PHTickets === true ? "Y" : "N"
            },
        };

        let res = await RequestServiceActions(
            body,
            credentials,
            ACTIONS.INSERT,
            setSnackbarInfo
        );
        if (res.status.code === 1) {
            await handleUpdateTable();
            setModalDetails((modalState) => !modalState);
        }
        setInRequest((inRequest) => !inRequest);
        setIsLoading((isLoading) => !isLoading);
    };

    useEffect(() => {
        setDisabledGroup(!formikRef?.current?.values?.agrupa)
    }, [formikRef])

    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                tipoDeDocumentoCod: "",
                tipoDeDocumentoNombre: "",
                tipoDeDocumentoDescripcion: "",
                enviaMail: true,
                agrupa: false,
                agrupaCant: 0,
                prioridadFirma: "N",
                PHFirmante: false,
                PHTickets: false
            }}
            validationSchema={Yup.object({
                tipoDeDocumentoCod: Yup.string(FORM_ERROR_MESSAGES.text)
                    .max(20, "Máximo 20 caracteres")
                    .nullable(),
                tipoDeDocumentoNombre: Yup.string(FORM_ERROR_MESSAGES.text)
                    .required(FORM_ERROR_MESSAGES.required)
                    .max(45, "Máximo 45 caracteres"),
                tipoDeDocumentoDescripcion: Yup.string(FORM_ERROR_MESSAGES.text)
                    .required(FORM_ERROR_MESSAGES.required)
                    .max(150, "Máximo 150 caracteres"),
                agrupa: Yup.boolean(),
                agrupaCant: Yup.number()
                    .when('agrupa', {
                        is: true,
                        then: (schema) => schema
                            .required(FORM_ERROR_MESSAGES.required)
                            .min(2, "Debe ser mayor a 1"),
                        otherwise: (schema) => schema.nullable()
                    })
            })}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Box display={"flex"} flexDirection={"row"} alignItems={"flex-end"} gap={"20px"} justifyContent={"space-between"} width={"100%"}>
                        <Box flex={2}>
                            <FormikTextInput
                                fullWidth={true}
                                name="tipoDeDocumentoNombre"
                                labelText={"Nombre"}
                            />
                        </Box>
                        <Box flex={1}>
                            <FormikTextInput
                                fullWidth={true}
                                name="tipoDeDocumentoCod"
                                labelText={"Código"}
                                autofocus={true}
                                onChange={(e) => {
                                    const filtered = e.target.value.replace(/[^a-zA-Z0-9._-]/g, "");
                                    formikRef.current.setFieldValue("tipoDeDocumentoCod", filtered);
                                }}
                            />
                        </Box>
                    </Box>
                    <FormikTextInput
                        fullWidth={true}
                        name="tipoDeDocumentoDescripcion"
                        labelText={"Descripción"}
                    />
                    <Box display={"flex"} flexDirection={"row"} alignItems={"flex-end"} gap={"20px"} marginTop={"20px"} justifyContent={"space-between"} width={"100%"}>
                        <Paper elevation={2} style={{ padding: "14px", height: "-webkit-fill-available", flex: "1", display: "flex", flexDirection: "column", gap: "8px" }}>
                            <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Orden de firmas</span>
                            <FormikSelectInput name={"prioridadFirma"} >
                                {
                                    prioridadList.map((prioridad) => (
                                        <option value={prioridad.value} key={prioridad.value}>{prioridad.label} </option>
                                    ))
                                }
                            </FormikSelectInput>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", display: "flex", flexDirection: "column", gap: "8px" }}>
                                <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Enviar mail</span>
                                <FormikYesOrNoInput name={"enviaMail"} />
                            </div>
                        </Paper>
                        <Paper elevation={2} style={{ padding: "14px", height: "-webkit-fill-available", flex: "1", display: "flex", flexDirection: "column", gap: "8px" }}>
                            <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Firmas Digitales</span>
                            <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Requiere Placeholders</span>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                <span>Firmas</span>
                                <FormikYesOrNoInput name={"PHFirmante"} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                <span >Tickets</span>
                                <FormikYesOrNoInput name={"PHTickets"} />
                            </div>
                        </Paper>
                        <Paper elevation={2} style={{ padding: "14px", height: "-webkit-fill-available", flex: "1" }}>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Agrupar Documentos</span>
                                <FormikYesOrNoInput name={"agrupa"} onChange={() => {
                                    setDisabledGroup((prev) => !prev)
                                    if (formikRef?.current?.values.agrupa === true) {
                                        formikRef.current.setFieldValue("agrupaCant", 0)
                                    }
                                }} />
                            </div>
                            <FormikTextInput
                                disabled={disabledGroup}
                                fullWidth={true}
                                name="agrupaCant"
                                labelText={"Documentos por grupo"}
                            />
                        </Paper>
                    </Box>

                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar" }}
                        hasConfirmationModal={true}
                    />

                    {isLoading && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
